import { Panel, PanelType } from "@fluentui/react";
import { PropsWithChildren, useEffect, useState } from "react";
import { CustomPanelProps } from "../Interfaces/CustomPanel.interfaces";
import { CustomPanelContent } from "./CustomPanelContent"; // Direct import instead of "./index"
import { CustomPanelHeader } from "./CustomPanelHeader";

const CustomPanel = ({
  children,
  dismissPanel,
  enablePanel,
  isLoading,
  panelTitle,
  panelType = PanelType.medium,
  headerStyle,
  customWidth
}: PropsWithChildren<CustomPanelProps>) => {
  const [isOpen, setIsOpen] = useState(enablePanel);

  const onDismissPanel = () => {
    setIsOpen(false);
    dismissPanel();
  };

  useEffect(() => setIsOpen(enablePanel), [enablePanel]);

  return (
    <Panel
      onRenderHeader={() => <CustomPanelHeader title={panelTitle} style={headerStyle} />}
      isLightDismiss
      isOpen={isOpen}
      onDismiss={onDismissPanel}
      type={panelType}
      customWidth={customWidth}
      closeButtonAriaLabel="Close"
      styles={{
        commands: { backgroundColor: "#fafafa !important" },
        main: { backgroundColor: "#fafafa !important" },
        navigation: { justifyContent: "space-between", alignItems: "baseline" },
        scrollableContent: { display: "flex", flexDirection: "column", height: "100%" },
        content: { flex: 1 }
      }}
    >
      <CustomPanelContent isLoading={isLoading}>{children}</CustomPanelContent>
    </Panel>
  );
};

export default CustomPanel;
